import Select from "react-select";
import { Option } from "./Options";
import { _classNames, _components, _filterOption, OPTIONS, Options } from "./constant";

interface IDropdownSelect extends Omit<React.ComponentProps<typeof Select>, "onChange"> {
  _options?: Options;
  onChange?: (opt: Option) => void; // To fix the annoying unknown type on the default onChange signature
  controlClassName?: string;
}

const DropdownSelect = ({
  className,
  _options,
  onChange,
  classNames,
  value,
  ...props
}: IDropdownSelect) => {
  if (_options) props.options = OPTIONS[_options];
  // React-select does not handle undefined properly
  if (value === undefined) value = null;
  return (
    <div className={className}>
      <Select
        classNames={{
          ..._classNames(props),
          ...classNames
        }}
        filterOption={_filterOption}
        components={_components}
        value={value}
        {...props}
        onChange={onChange as any}
      />
    </div>
  );
};

export default DropdownSelect;
